import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  /* Metade da largura da área visível menos metade do container Toast */
  right: calc(100vw / 2 - 180px);
  padding: 0 10px 0 0;
  overflow: hidden;

  z-index: 500000;
`;
